import { type InsightWrapperVariant } from "./types";

export function getInsightBackground(variant: InsightWrapperVariant) {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (variant) {
    case "hero-market-context": {
      return `linear-gradient(344.15deg, #DDE9F4 -6.58%, #D1E4F5 1.35%, #7CC1FF 32.65%, #7CC1FF 66.27%, #EEF7FF 114.83%);`;
    }

    case "shift-volume": {
      return `linear-gradient(12deg, #EA6060 0%, #FF5858 5.92%, #FD7A7A 30.87%, #FF9494 53.49%, #FF5F5F 74.19%), #FFFFFF;`;
    }

    case "morning-mvp": {
      return `radial-gradient(163.33% 75.43% at 29.87% 76.79%, #FF962D 0%, #FFB92D 11.11%, #FFAE2D 19.64%, #FFAE2D 31.49%, #FFCB40 46.09%, #F3E1B5 89.04%)`;
    }

    case "evening-all-star": {
      return `radial-gradient(243.6% 112.5% at 43.2% 106.83%, #FAAD66 16.18%, #FA9A62 40.73%, #F68248 58.95%, #FF712B 89.1%)`;
    }

    case "night-shift-legend": {
      return `radial-gradient(249.73% 115.33% at 106.67% -6.4%, #3F6AA3 13.6%, #242A4D 37.45%, #13151D 60.12%, #0E1124 72.72%, #17273D 84.22%, #3F6AA3 95.06%)`;
    }

    case "all-hours-champion": {
      return `linear-gradient(180deg, #FFD153 0%, #FFB628 50%, #FF9913 100%)`;
    }

    case "urgent-champion": {
      return "radial-gradient(175.11% 109.17% at -7.2% -6.53%, #6565CE 16.88%, #8E9FEC 52.54%, #BACEFF 71.15%, #6565CE 99.73%)";
    }

    case "planning-ahead": {
      return `radial-gradient(176.99% 110.34% at 100% -2.4%, #6565CE 9.63%, #8E9FEC 54.1%, #BACEFF 73.73%, #6565CE 92.29%)`;
    }

    case "total-earnings": {
      return `linear-gradient(341.74deg, #95D348 14.07%, #A9DF6A 27.32%, #C1F088 37.74%, #ADE170 49.78%, #95D348 70.48%), #FFFEFE`;
    }

    case "total-earnings-lifetime": {
      return `linear-gradient(339.74deg, #95D348 8.94%, #A9DF6A 36.13%, #C1F088 46.3%, #ADE170 55.93%, #95D348 86.3%)`;
    }

    case "agent-req-diversity": {
      return `radial-gradient(75.81% 33.25% at 50.13% 74.01%, #F6F3F1 11.54%, #FF9FAC 48%, #F67795 100%)`;
    }

    case "distance-and-commute": {
      return `linear-gradient(329.81deg, #3A96EB 7.15%, #85C2FC 18.4%, #B2D8FC 29.04%, #D6E9FA 37.46%, #B1D8FC 46.57%, #85C2FC 56.24%, #49A3F7 73.11%, #3A96EB 90.5%)`;
    }

    case "top-workplaces": {
      return `linear-gradient(167.79deg, #50599F 20.55%, #7D78DD 48.83%, #8588E0 57.41%, #9793EC 73.57%, #9B9EF0 84.17%, #6F7CB3 102.85%)`;
    }

    case "team-and-connections": {
      return `radial-gradient(179.95% 63.61% at 62% 34.42%, #3996EB 9.91%, #BADDFE 41.53%, #9DCEFB 49.53%, #8BC7FC 60.52%, #5EB2FE 74.63%, #3587D1 94.21%)`;
    }

    case "community-reviews": {
      return `linear-gradient(347.27deg, #FFC32C 6.44%, #FFDB8B 28.08%, #FFE7BC 37.84%, #FFECDA 42.74%, #FEECCA 50.11%, #FFC637 71.31%);`;
    }

    case "summary": {
      return `linear-gradient(180deg, #7CC1FF 0%, #7CC1FF 39.9%, #D1E4F5 68.27%, #F6F3F1 100%);`;
    }

    default: {
      return `linear-gradient(174.67deg, #CCE7FF 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }
  }
}
